	export enum InsurancePlanProductModifierCopyTypeEnum {
		Overwrite = 1,
		Merge = 2
	}
